<template>
  <header class="header">
    <div class="header__left">
      <div class="header__logo">
        <nuxt-link to="/lp/create">
          <img src="/img/lp-create/create-logo.svg" alt="Legal Script" width="220" height="37">
        </nuxt-link>
      </div>
    </div>
    <div class="header__right">
      <div class="header__menu__sub">
        <ul>
          <li><nuxt-link class="button button--create-submenu" :to="authLink('/auth/login-application')">ログイン</nuxt-link></li>
          <li class="pc-only"><nuxt-link class="button button--create-menu" :to="authLink('/auth/register-application')">無料<span class="pc-only">アカウント</span>登録<i class="las la-chevron-circle-right"></i></nuxt-link></li>
        </ul>
      </div>
    </div>
</header>
</template>

<script>
  export default {
    name: 'f-header-lp-create',
    methods: {
      authLink(path) {
        return {
          path,
          query: this.$route.name === 'landing-url'
            ? { ...this.$route.query, registerLandingUrl: this.$route.params.url }
            : { ...this.$route.query }
        };
      }
    }
  }
</script>
